import { CouponReconciliationDto } from 'app/client-core/dtos/coupon-reconciliation-dto.model';
import { DoReconciliationDto } from './../dtos/do-reconciliation-dto.model';
import { PoReconciliationDto } from './../dtos/po-reconciliation-dto.model';
import { Injectable, NgZone } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { ApiResponse, ApiPagedResponse, PaginationInfo } from "app/client-core/api-response-models";
import { ApiService } from "../api.service";
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { PromoReconciliationDto } from '../dtos/promo-reconciliation-dto.model';
import { HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { MindShareDto } from '../dtos/mindshare.model';
import { MindshareComponentDataDto } from '../dtos/mindshare-component.model';

@Injectable()
export class ExpensesManagmentService {
    // public campaignThemeSaved: Subject<CampaignThemeId>;

    constructor(
        private apiService: ApiService,
        private router: Router,
        private zone: NgZone,
        private _sanitizer: DomSanitizer,
    ) {
        // this.campaignThemeSaved = new Subject<CampaignThemeId>();
    }

    /**
     * Returns lookup list of projects
     * @param params
     */
    getDoExpenses(params?: any): Observable<ApiResponse<ApiPagedResponse<any>>> {
        console.log('>>getCategories', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<any>>('expensesmanagment/expenses-do', params);
    }

    /**
     * Returns lookup list of projects
     * @param params
     */
    getPoExpenses(params?: any): Observable<ApiResponse<ApiPagedResponse<any>>> {
        console.log('>>getCategories', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<any>>('expensesmanagment/expenses-po', params);
    }

    /**
     * Returns lookup list of projects
     * @param params
     */
    getCouponExpenses(params?: any): Observable<ApiResponse<ApiPagedResponse<any>>> {
        return this.apiService.get<ApiPagedResponse<any>>('expensesmanagment/expenses-coupon', params);
    }

    /**
     * Returns lookup list of projects
     * @param params
     */
    getPromoExpenses(params?: any): Observable<ApiResponse<ApiPagedResponse<any>>> {
        console.log('>>getCategories', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<any>>('expensesmanagment/expenses-promo', params);
    }

    getPromoReconciliation(id): Observable<ApiResponse<any>> {
        return this.apiService.get<any>(`expensesmanagment/promocode-reconciliation/${id}`, {});
    }

    getPoReconciliation(id): Observable<ApiResponse<any>> {
        return this.apiService.get<any>(`expensesmanagment/po-reconciliation/${id}`, {});
    }

    getDoReconciliation(id): Observable<ApiResponse<any>> {
        return this.apiService.get<any>(`expensesmanagment/do-reconciliation/${id}`, {});
    }

    getCouponReconciliation(id): Observable<ApiResponse<any>> {
        return this.apiService.get<any>(`expensesmanagment/coupon-reconciliation/${id}`, {});
    }

    approvePoReconciliation(model: PoReconciliationDto): Observable<ApiResponse<any>> {
        return this.apiService.put<any>(`expensesmanagment/po-reconciliation-approve`, model);
    }

    reallocatePoReconciliation(model: PoReconciliationDto): Observable<ApiResponse<any>> {
        return this.apiService.put<any>(`expensesmanagment/po-reconciliation-reallocate`, model);
    }

    saverefreshPoReconciliation(model: PoReconciliationDto): Observable<ApiResponse<any>> {
        return this.apiService.put<any>(`expensesmanagment/po-reconciliation-saverefresh`, model);
    }

    savesubmitPoReconciliation(model: PoReconciliationDto): Observable<ApiResponse<any>> {
        return this.apiService.put<any>(`expensesmanagment/po-reconciliation-savesubmit`, model);
    }

    saverefreshPromoReconciliation(model: PromoReconciliationDto): Observable<ApiResponse<any>> {
        return this.apiService.put<any>(`expensesmanagment/promo-reconciliation-saverefresh`, model);
    }

    saverefreshDoReconciliation(model: DoReconciliationDto): Observable<ApiResponse<any>> {
        return this.apiService.put<any>(`expensesmanagment/do-reconciliation-saverefresh`, model);
    }

    reallocateDoReconciliation(model: DoReconciliationDto): Observable<ApiResponse<any>> {
        return this.apiService.put<any>(`expensesmanagment/do-reconciliation-reallocate`, model);
    }

    saverefreshCouponReconciliation(model: CouponReconciliationDto): Observable<ApiResponse<any>> {
        return this.apiService.put<any>(`expensesmanagment/coupon-reconciliation-saverefresh`, model);
    }

    reallocateCouponReconciliation(model: CouponReconciliationDto): Observable<ApiResponse<any>> {
        return this.apiService.put<any>(`expensesmanagment/coupon-reconciliation-reallocate`, model);
    }

    reallocatePromoReconciliation(model: PromoReconciliationDto): Observable<ApiResponse<any>> {
        return this.apiService.put<any>(`expensesmanagment/promo-reconciliation-reallocate`, model);
    }

    isPoInUse(code: string, componentId: number): Observable<ApiResponse<boolean>> {
        return this.apiService.get<any>(`expensesmanagment/po-inuse`, {
            code,
            componentId
        });
    }

    isDoInUse(code: string, componentId: number): Observable<ApiResponse<boolean>> {
        return this.apiService.get<any>(`expensesmanagment/do-inuse`, {
            code,
            componentId
        });
    }

    isCouponInUse(code: string, componentId: number, couponType: string): Observable<ApiResponse<boolean>> {
        return this.apiService.get<any>(`expensesmanagment/coupon-inuse`, {
            code,
            componentId,
            couponType
        });
    }

    uploadPo(file: File): Observable<HttpEvent<any>> {

        const formData = new FormData();
        formData.append('file', file);

        const params = new HttpParams();
        const options = {
            params: params,
            reportProgress: true,
        };

        // tslint:disable-next-line:max-line-length
        const req = new HttpRequest('POST', encodeURI(this.apiService.getApiUrlFor(`expensesmanagment/import-po`, )), formData, options);
        return this.apiService.http.request(req);
    }

    uploadCoupon(file: File): Observable<HttpEvent<any>> {

        const formData = new FormData();
        formData.append('file', file);

        const params = new HttpParams();
        const options = {
            params: params,
            reportProgress: true,
        };

        // tslint:disable-next-line:max-line-length
        const req = new HttpRequest('POST', encodeURI(this.apiService.getApiUrlFor(`expensesmanagment/import-coupon`, )), formData, options);
        return this.apiService.http.request(req);
    }

    uploadPromo(file: File): Observable<HttpEvent<any>> {

        const formData = new FormData();
        formData.append('file', file);

        const params = new HttpParams();
        const options = {
            params: params,
            reportProgress: true,
        };

        // tslint:disable-next-line:max-line-length
        const req = new HttpRequest('POST', encodeURI(this.apiService.getApiUrlFor(`expensesmanagment/import-promocode`, )), formData, options);
        return this.apiService.http.request(req);
    }

    processCoupon() {
        return this.apiService.put<any>(`expensesmanagment/process-import-coupon`, {});
    }

    processPo() {
        return this.apiService.put<any>(`expensesmanagment/process-import-po`, {});
    }

    processPromo() {
        return this.apiService.put<any>(`expensesmanagment/process-import-promocode`, {});
    }

    removeNewPromo() {
        return this.apiService.put<any>(`expensesmanagment/remove-import-promocode`, {});
    }

    processDo(model) {
        return this.apiService.put<any>(`expensesmanagment/process-import-do`, model);
    }

    removeNewCoupon() {
        return this.apiService.put<any>(`expensesmanagment/remove-import-coupon`, {});
    }

    removeNewPo() {
        return this.apiService.put<any>(`expensesmanagment/remove-import-po`, {});
    }

    doInvoiceInUse(docode: string, invoice: number): Observable<ApiResponse<boolean>> {
        return this.apiService.get<any>(`expensesmanagment/check-do-invoice`, {
            docode,
            invoice
        });
    }

    tryAssignPo() {
        return this.apiService.post<any>(`expensesmanagment/try-assign-po`, {});
    }

    tryAssignDo() {
        return this.apiService.post<any>(`expensesmanagment/try-assign-do`, {});
    }

    tryAssignCoupon() {
        return this.apiService.post<any>(`expensesmanagment/try-assign-coupon`, {});
    }

    tryAssignPromo() {
        return this.apiService.post<any>(`expensesmanagment/try-assign-promo`, {});
    }

    getMindShare(status?: string, openSearch?:string, retailers?: string, budgetYear?): Observable<ApiResponse<MindShareDto[]>> {
        return this.apiService.get<MindShareDto[]>(`expensesmanagment/expenses-mindshare?statusId=${status}&openSearch=${openSearch}&retailers=${retailers}&budgetYear=${budgetYear}`, {});
    }

    getMindShareComponent(id?: number): Observable<ApiResponse<MindshareComponentDataDto[]>> {
        return this.apiService.get<MindshareComponentDataDto[]>(`expensesmanagment/expenses-mindshare-component/${id}`, {});
    }

    updateMindShareComponent(id: number, invoiceId: number, selected: boolean): Observable<ApiResponse<MindshareComponentDataDto[]>> {
        return this.apiService.post<MindshareComponentDataDto[]>(`expensesmanagment/expenses-mindshare-update-component/${id}/${invoiceId}?selected=${selected}`, {});
    }
}



// WEBPACK FOOTER //
// ./src/app/client-core/services/expenses-managment.service.ts